import { Component, Input, OnInit, inject } from '@angular/core';
import { Patient } from '../../../core/models/patient.model';
import { MinimalPatientAttachment } from '../../../core/models/minimal-patient-attachment.model';
import { PatientListParams, PagedMinimalPatientAttachments, PatientAttachmentsService } from '../../../core/services/patient-attachments.service';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-patient-prescriber-consult-notes',
    templateUrl: './patient-prescriber-consult-notes.component.html',
    styleUrls: ['./patient-prescriber-consult-notes.component.scss'],
    imports: [RouterLink, MatProgressSpinner, DatePipe]
})
export class PatientPrescriberConsultNotesComponent implements OnInit {
  private patientAttachmentsService = inject(PatientAttachmentsService);

  @Input() patient: Patient;
  @Input() prescriberId: number;

  loading = false;
  patientAttachments: MinimalPatientAttachment[] = [];

  ngOnInit() {
    this.loadPatientAttachments();
  }

  private loadPatientAttachments() {
    this.loading = true;

    const params = new PatientListParams();
    params.prescriberId = this.prescriberId;

    this.patientAttachmentsService
      .getList(this.patient.id, params)
      .subscribe((pageResults: PagedMinimalPatientAttachments) => {
        this.loading = false;
        this.patientAttachments = pageResults.patientAttachments;
      });
  }
}
